/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DemoRefreshResponse
 */
export interface DemoRefreshResponse {
    /**
     * 
     * @type {string}
     * @memberof DemoRefreshResponse
     */
    taskId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoRefreshResponse
     */
    conversationId: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DemoRefreshResponse
     */
    proposalIds: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof DemoRefreshResponse
     */
    fallback?: boolean;
}

/**
 * Check if a given object implements the DemoRefreshResponse interface.
 */
export function instanceOfDemoRefreshResponse(value: object): value is DemoRefreshResponse {
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('proposalIds' in value) || value['proposalIds'] === undefined) return false;
    return true;
}

export function DemoRefreshResponseFromJSON(json: any): DemoRefreshResponse {
    return DemoRefreshResponseFromJSONTyped(json, false);
}

export function DemoRefreshResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemoRefreshResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['task_id'] == null ? undefined : json['task_id'],
        'conversationId': json['conversation_id'],
        'proposalIds': json['proposal_ids'],
        'fallback': json['fallback'] == null ? undefined : json['fallback'],
    };
}

  export function DemoRefreshResponseToJSON(json: any): DemoRefreshResponse {
      return DemoRefreshResponseToJSONTyped(json, false);
  }

  export function DemoRefreshResponseToJSONTyped(value?: DemoRefreshResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task_id': value['taskId'],
        'conversation_id': value['conversationId'],
        'proposal_ids': value['proposalIds'],
        'fallback': value['fallback'],
    };
}

